(function () {
  if (window.__shMisato) return;
  window.__shMisato = true;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var desk = window.matchMedia('(min-width: 990px)');
  function qsa(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  var ICON_BAG = "<svg class='sh-svg' viewBox='0 0 24 24' aria-hidden='true' focusable='false'><path d='M5 8h14l-1.2 12.2a1 1 0 0 1-1 .8H7.2a1 1 0 0 1-1-.8L5 8z'/><path d='M8.5 8V6.5a3.5 3.5 0 0 1 7 0V8'/></svg>";
  var ICON_HEART = "<svg class='sh-svg' viewBox='0 0 24 24' aria-hidden='true' focusable='false'><path d='M12 20.5s-7.5-4.6-9.2-9.4C1.7 7.9 3.8 4.5 7.2 4.5c2 0 3.6 1.1 4.8 2.8 1.2-1.7 2.8-2.8 4.8-2.8 3.4 0 5.5 3.4 4.4 6.6-1.7 4.8-9.2 9.4-9.2 9.4z'/></svg>";

  function initAnn(c) {
    qsa('[data-sh-ann]', c).forEach(function (el) {
      if (el.__i) return; el.__i = 1;
      var m = qsa('.sh-ann__msg', el); if (m.length < 2) return;
      var i = 0;
      setInterval(function () { m[i].classList.remove('is-active'); i = (i + 1) % m.length; m[i].classList.add('is-active'); }, (parseInt(el.dataset.speed, 10) || 4) * 1000);
    });
  }

  function initHeader(c) {
    qsa('[data-sh-header]', c).forEach(function (h) {
      if (h.__i) return; h.__i = 1;
      var drawer = h.querySelector('[data-sh-drawer]');
      var search = h.querySelector('[data-sh-search]');
      function open() { if (!drawer) return; drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.body.classList.add('sh-lock'); }
      function close() { if (!drawer) return; drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.body.classList.remove('sh-lock'); }
      qsa('[data-sh-open-drawer]', h).forEach(function (b) { b.addEventListener('click', open); });
      qsa('[data-sh-close-drawer]', h).forEach(function (b) { b.addEventListener('click', close); });
      qsa('[data-sh-toggle-search]', h).forEach(function (b) {
        b.addEventListener('click', function () {
          if (!search) return;
          var o = search.classList.toggle('is-open');
          if (o) { var inp = search.querySelector('input[type=search]'); if (inp) inp.focus(); }
        });
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { close(); if (search) search.classList.remove('is-open'); } });
    });
  }

  function initSlider(c) {
    qsa('[data-sh-slider]', c).forEach(function (el) {
      if (el.__i) return; el.__i = 1;
      var track = el.querySelector('[data-sh-track]');
      var slides = qsa('[data-sh-slide]', el);
      var dots = qsa('[data-sh-dot]', el);
      var n = slides.length, idx = 0, timer, t;
      if (!track || n < 2) return;
      function go(i) { idx = (i + n) % n; track.scrollTo({ left: slides[idx].offsetLeft, behavior: 'smooth' }); }
      function mark() {
        idx = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === idx); d.setAttribute('aria-current', k === idx ? 'true' : 'false'); });
      }
      var speed = (parseInt(el.dataset.autoplay, 10) || 0) * 1000;
      function stop() { clearInterval(timer); }
      function start() { stop(); if (speed) timer = setInterval(function () { if (!document.hidden) go(idx + 1); }, speed); }
      track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(mark, 60); }, { passive: true });
      dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); start(); }); });
      var p = el.querySelector('[data-sh-prev]'), nx = el.querySelector('[data-sh-next]');
      if (p) p.addEventListener('click', function () { go(idx - 1); start(); });
      if (nx) nx.addEventListener('click', function () { go(idx + 1); start(); });
      el.addEventListener('mouseenter', stop);
      el.addEventListener('mouseleave', start);
      track.addEventListener('touchstart', stop, { passive: true });
      track.addEventListener('touchend', start, { passive: true });
      start();
    });
  }

  function initRail(c) {
    qsa('[data-sh-rail]', c).forEach(function (el) {
      if (el.__i) return; el.__i = 1;
      var tr = el.querySelector('[data-sh-track]');
      var p = el.querySelector('[data-sh-prev]'), n = el.querySelector('[data-sh-next]');
      var bar = el.parentNode.querySelector('[data-sh-bar]');
      if (!tr) return;
      function upd() {
        if (p && n) { p.disabled = tr.scrollLeft <= 4; n.disabled = tr.scrollLeft + tr.clientWidth >= tr.scrollWidth - 4; }
        if (bar) {
          var ratio = Math.min(1, tr.clientWidth / Math.max(tr.scrollWidth, 1));
          bar.style.width = (ratio * 100) + '%';
          bar.style.transform = 'translateX(' + (tr.scrollLeft / Math.max(tr.clientWidth, 1) * 100) + '%)';
          bar.parentNode.style.display = ratio >= 1 ? 'none' : '';
        }
      }
      function step(d) { tr.scrollBy({ left: d * tr.clientWidth * 0.9, behavior: 'smooth' }); }
      if (p) p.addEventListener('click', function () { step(-1); });
      if (n) n.addEventListener('click', function () { step(1); });
      tr.addEventListener('scroll', upd, { passive: true });
      window.addEventListener('resize', upd);
      window.addEventListener('load', upd);
      upd();
    });
  }

  function initFoot() {
    qsa('[data-sh-foot-col]').forEach(function (d) { if (desk.matches) d.setAttribute('open', ''); });
  }

  /* link: true = "View bag", or { href, label } */
  function toast(msg, link) {
    var t = document.querySelector('.sh-toast');
    if (!t) { t = document.createElement('div'); t.className = 'sh-toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.innerHTML = '';
    var s = document.createElement('span'); s.textContent = msg; t.appendChild(s);
    if (link) {
      var a = document.createElement('a');
      a.href = link === true ? root + 'cart' : link.href;
      a.textContent = link === true ? 'View bag' : link.label;
      t.appendChild(a);
    }
    t.classList.add('is-show');
    clearTimeout(t.__t); t.__t = setTimeout(function () { t.classList.remove('is-show'); }, 3600);
  }

  /* ---------- Wishlist: saved in this browser (localStorage), no app needed ---------- */
  var WKEY = 'sh-wishlist-v1';
  function wlGet() {
    try { var a = JSON.parse(localStorage.getItem(WKEY) || '[]'); return Array.isArray(a) ? a.filter(function (x) { return typeof x === 'string' && x; }) : []; }
    catch (e) { return []; }
  }
  function wlSave(a) {
    try { localStorage.setItem(WKEY, JSON.stringify(a)); } catch (e) {}
    wlSync();
  }
  function wlUrl() {
    var l = document.querySelector('[data-sh-wish-link]');
    return (l && l.getAttribute('href')) || root + 'pages/wishlist';
  }
  function wlSync(c) {
    var a = wlGet();
    qsa('[data-sh-wish]', c).forEach(function (b) {
      var on = a.indexOf(b.getAttribute('data-sh-wish')) > -1;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var title = b.getAttribute('data-sh-title') || 'this item';
      b.setAttribute('aria-label', on ? 'Remove ' + title + ' from wishlist' : 'Add ' + title + ' to wishlist');
    });
    qsa('[data-sh-wish-count]').forEach(function (n) { n.textContent = a.length; n.setAttribute('data-count', a.length); });
  }

  function money(cents, fmt) {
    fmt = fmt || '₹{{amount}}';
    function f(n, d, ts, ds) {
      var s = (n / 100).toFixed(d).split('.');
      s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts);
      return s.length > 1 ? s[0] + ds + s[1] : s[0];
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      switch (k) {
        case 'amount_no_decimals': return f(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return f(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return f(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return f(cents, 2, "'", '.');
        default: return f(cents, 2, ',', '.');
      }
    });
  }

  function imgUrl(u, w) {
    if (!u) return '';
    if (typeof u === 'object') u = u.src || '';
    if (u.indexOf('//') === 0) u = 'https:' + u;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function wlCard(p, fmt) {
    var v = p.variants.filter(function (x) { return x.available; })[0] || p.variants[0];
    var sale = p.compare_at_price > p.price;
    var off = sale ? Math.round((p.compare_at_price - p.price) * 100 / p.compare_at_price) : 0;
    var img = p.featured_image || (p.images && p.images[0]);
    var alt = p.images && p.images[1];
    var media = img
      ? "<img class='sh-card__img' src='" + esc(imgUrl(img, 600)) + "' srcset='" + esc(imgUrl(img, 360)) + " 360w, " + esc(imgUrl(img, 600)) + " 600w, " + esc(imgUrl(img, 900)) + " 900w' sizes='(min-width: 990px) 23vw, 46vw' alt='" + esc(p.title) + "' loading='lazy'>"
        + (alt ? "<img class='sh-card__alt' src='" + esc(imgUrl(alt, 600)) + "' alt='' loading='lazy'>" : '')
      : '';
    var badge = !p.available ? "<span class='sh-badge sh-badge--light'>Sold out</span>" : (sale ? "<span class='sh-badge'>" + off + "% Off</span>" : '');
    var add;
    if (!p.available) add = "<span class='sh-card__add is-soldout' aria-disabled='true'><span>Sold Out</span></span>";
    else if (p.variants.length === 1) add = "<button type='button' class='sh-card__add' data-sh-add='" + v.id + "' data-sh-title='" + esc(p.title) + "'>" + ICON_BAG + "<span>Add to Bag</span></button>";
    else add = "<a href='" + esc(p.url) + "' class='sh-card__add'>" + ICON_BAG + "<span>Select Options</span></a>";
    return "<div class='sh-rail__item' data-sh-wl-item='" + esc(p.handle) + "'><div class='sh-card'><div class='sh-card__top'>"
      + "<a href='" + esc(p.url) + "' class='sh-card__media' tabindex='-1' aria-hidden='true'>" + media + "</a>"
      + badge
      + "<button type='button' class='sh-wish is-active' data-sh-wish='" + esc(p.handle) + "' data-sh-title='" + esc(p.title) + "' aria-pressed='true'>" + ICON_HEART + "</button>"
      + add
      + "</div><div class='sh-card__info'>"
      + "<a href='" + esc(p.url) + "' class='sh-card__title'>" + esc(p.title) + "</a>"
      + "<div class='sh-card__price'><strong>" + (p.price_varies ? 'From ' : '') + money(p.price, fmt) + "</strong>"
      + (sale ? "<s>" + money(p.compare_at_price, fmt) + "</s><span class='sh-card__off'>" + off + "% off</span>" : '')
      + "</div><span class='sh-card__tax'>Inclusive of all taxes</span></div></div></div>";
  }

  function wlEmptyState(page) {
    var grid = page.querySelector('[data-sh-wl-grid]');
    var n = grid ? grid.children.length : 0;
    page.classList.toggle('is-empty', n === 0);
    var c = page.querySelector('[data-sh-wl-count]');
    if (c) c.textContent = n ? n + (n === 1 ? ' saved piece' : ' saved pieces') : '';
  }

  function initWishlistPage(c) {
    qsa('[data-sh-wishlist-page]', c).forEach(function (page) {
      if (page.__i) return; page.__i = 1;
      var grid = page.querySelector('[data-sh-wl-grid]');
      var fmt = page.getAttribute('data-money');
      var handles = wlGet();
      page.classList.remove('is-loading');
      if (!handles.length) { grid.innerHTML = ''; wlEmptyState(page); return; }
      page.classList.add('is-loading');
      Promise.all(handles.map(function (h) {
        return fetch(root + 'products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
      })).then(function (list) {
        var found = list.filter(Boolean);
        /* drop products that no longer exist */
        if (found.length !== handles.length) wlSave(found.map(function (p) { return p.handle; }));
        grid.innerHTML = found.map(function (p) { return wlCard(p, fmt); }).join('');
        page.classList.remove('is-loading');
        wlEmptyState(page);
        wlSync(page);
      });
    });
  }

  document.addEventListener('click', function (e) {
    var w = e.target.closest && e.target.closest('[data-sh-wish]');
    if (w) {
      e.preventDefault();
      e.stopPropagation();
      var h = w.getAttribute('data-sh-wish');
      var a = wlGet();
      var i = a.indexOf(h);
      w.classList.remove('is-pop'); void w.offsetWidth; w.classList.add('is-pop');
      if (i > -1) {
        a.splice(i, 1);
        wlSave(a);
        toast('Removed from wishlist');
        var page = w.closest('[data-sh-wishlist-page]');
        var item = page && w.closest('[data-sh-wl-item]');
        if (item) { item.parentNode.removeChild(item); wlEmptyState(page); }
      } else {
        a.unshift(h);
        wlSave(a);
        toast('Saved to wishlist', { href: wlUrl(), label: 'View wishlist' });
      }
      return;
    }
    var b = e.target.closest && e.target.closest('[data-sh-add]');
    if (b) {
      e.preventDefault();
      b.classList.add('is-loading');
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(b.getAttribute('data-sh-add'), 10), quantity: 1 }] })
      })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () { return fetch(root + 'cart.js').then(function (r) { return r.json(); }); })
        .then(function (cart) {
          qsa('[data-sh-cart-count]').forEach(function (c) { c.textContent = cart.item_count; c.setAttribute('data-count', cart.item_count); });
          toast((b.getAttribute('data-sh-title') || 'Item') + ' added to bag', true);
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        })
        .catch(function (err) { toast((err && (err.description || err.message)) || 'Could not add this item', false); })
        .then(function () { b.classList.remove('is-loading'); });
      return;
    }
    var tg = e.target.closest && e.target.closest('[data-sh-about-toggle]');
    if (tg) {
      var s = tg.closest('.sh-about');
      var o = s.classList.toggle('is-open');
      tg.textContent = o ? tg.getAttribute('data-less') : tg.getAttribute('data-more');
      tg.setAttribute('aria-expanded', o ? 'true' : 'false');
      return;
    }
    var sm = e.target.closest && e.target.closest('[data-sh-foot-col] > summary');
    if (sm && desk.matches) e.preventDefault();
  }, true);

  /* keep hearts in sync across tabs and for cards added later (filters, pagination, quick view) */
  window.addEventListener('storage', function (e) { if (e.key === WKEY) wlSync(); });
  var mt;
  if (window.MutationObserver) {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes && muts[i].addedNodes.length) { clearTimeout(mt); mt = setTimeout(function () { wlSync(); }, 80); return; }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  function init(c) { initAnn(c); initHeader(c); initSlider(c); initRail(c); initFoot(); initWishlistPage(c); wlSync(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }); else init(document);
  if (desk.addEventListener) desk.addEventListener('change', initFoot);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
